import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthorisationService } from '../../services/authorisation/authorisation.service';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material';
import { EmiErrorComponent } from 'src/app/snack-bar/emi-error/emi-error.component';
import { LoginRenderingService } from 'src/app/services/login/login-rendering.service';
import { ApiService } from 'src/app/services/api/api.service';
import { BorrowerRenderingService } from 'src/app/services/borrower/borrower-rendering.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthorisationService, 
        private loginService: LoginRenderingService, 
        private router: Router, 
        private snackBar: MatSnackBar, 
        private data: ApiService,
        private borrowerRenderingService: BorrowerRenderingService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if(!this.borrowerRenderingService.docErrorFlag){
            if (err.error && err.error.uniqueId == 40003) {
                // this.openSnackBar();
                this.data.openSnackBar('The requested details were not found! Please try selecting other options', '', 'warningSnackBar');
            }
            else if (err.error && err.error.uniqueId == 40005) {
                //  private int uniqueId; // the error code
                // private String componentId; // not in use
                // private String errorCode ; // 
                // private String errorMessage;
                this.data.openSnackBar(err.error.errorMessage, '', 'errorFormSnackBar');
            }
            else if (err.status === 403) {
                this.router.navigate(['/error', { id: 403 }]);
            }
            else if (err.status == 500) {
                this.router.navigate(['/error', { id: 500 }]);
            }
        }
            // const error = err.error.message || err.statusText;
            return throwError(err);
        
        }))

        // error code -> 40005 
        // reposnse status -> 404, "Not Found"
        // error message -> text returned from Indus 
    }

    // openSnackBar() {
    //     const snackbar = new MatSnackBarConfig()
    //     snackbar.panelClass = ['warningSnackBar'],
    //         snackbar.duration = 3000,
    //         snackbar.verticalPosition = 'top'
    //     this.snackBar.openFromComponent(WarningComponent, snackbar);
    // }


    openEmiSnackBar() {
        const snackbar = new MatSnackBarConfig()
        snackbar.panelClass = ['errorFormSnackBar'],
            snackbar.duration = 8000,
            snackbar.verticalPosition = 'top'
        this.snackBar.openFromComponent(EmiErrorComponent, snackbar);
    }
}